module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "cart",
    attrs: {
      "to": "/cart"
    }
  }, [_c('i', {
    staticClass: "cart__icon icon-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "cart__notification"
  }, [_vm._v(_vm._s(_vm.cartItemCount))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12e52214","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartStatusIcon.vue
// module id = 689
// module chunks = 1